import { useEffect, useState } from 'react';
import {
  Container,
  Link,
  SectionBannerCloseButton,
  SectionBannerContent,
  SectionBannerDescription,
  SectionBannerIcon,
  SectionBannerRoot,
  SectionBannerTitle,
} from '@melio/penny';

import { useAnalytics } from '../../analytics';
import { getEntryPoint } from '../../session';
import { dismissDomainTransitionBanner, isDomainTransitionBannerDismissed } from './domainTransitionBannerCookie';

const HELP_ARTICLE_URL = 'https://help.melio.com/hc/en-us/articles/26149261215132-Updating-your-saved-login-details-for-Melio-com';

export const DomainTransitionBanner = () => {
  const { track } = useAnalytics();
  const [isDismissed, setIsDismissed] = useState(isDomainTransitionBannerDismissed);

  const trackView = () => {
    track({
      eventName: 'Connection-View',
      properties: { PageName: 'domain-transition-banner', Flow: 'sign-in', Intent: 'sign-in', EntryPoint: getEntryPoint() },
    });
  };

  const trackClick = (cta: 'see-how' | 'dismiss') => {
    track({
      eventName: 'Connection-Click',
      properties: {
        PageName: 'domain-transition-banner',
        Flow: 'sign-in',
        Intent: 'sign-in',
        EntryPoint: getEntryPoint(),
        Cta: cta,
      },
    });
  };

  useEffect(() => {
    if (!isDismissed) {
      trackView();
    }
    // Only track the initial mount's visibility, not every isDismissed transition.
  }, []);

  const handleSeeHow = (e: React.MouseEvent) => {
    e.preventDefault();
    trackClick('see-how');
    window.open(HELP_ARTICLE_URL, '_blank', 'noopener,noreferrer');
  };

  const handleDismiss = () => {
    dismissDomainTransitionBanner();
    setIsDismissed(true);
    trackClick('dismiss');
  };

  if (isDismissed) {
    return null;
  }

  return (
    <Container width="full" maxWidth="480px" paddingBottom="xs">
      <SectionBannerRoot variant="informative" data-testid="domain-transition-banner">
        <SectionBannerIcon />
        <SectionBannerContent>
          <SectionBannerTitle>Update your saved sign-in</SectionBannerTitle>
          <SectionBannerDescription>
            We&apos;ve moved to melio.com. Update your saved email and password so they still autofill.
          </SectionBannerDescription>
          <Link href="#" variant="standalone" size="medium" label="See how" onClick={handleSeeHow} data-testid="see-how-link" />
        </SectionBannerContent>
        <SectionBannerCloseButton onClick={handleDismiss} />
      </SectionBannerRoot>
    </Container>
  );
};
